import { useEffect, useState } from "react";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const useBrowser = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("tablet"));
  const isDesktop = useMediaQuery(theme.breakpoints.up("desktop"));

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [pageBody, setPageBody] = useState({
    width: window.innerWidth,
    height: window.innerHeight - 140,
  });

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    setWindowHeight(window.innerHeight);
    setPageBody({
      width: window.innerWidth,
      height: window.innerHeight - 140,
    });
  }, [window.innerWidth, window.innerHeight]);

  return {
    windowWidth,
    windowHeight,
    pageBody,
  };
};

export default useBrowser;
